import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { IncodeAuthorisationLink } from '../components/IncodeAuthorisationLink/IncodeAuthorisationLink';
import { IncodeFooter } from '../components/IncodeFooter';
import { INCODE_PROGRESS_STATUS, INCODE_PROGRESS_STEP, INCODE_ROUTES, IncodeStepProps } from '../IncodeSDKHelpers';
import { usePostIncodeProgress } from '../progress/incodeProgress';

import LocalTexts from './Incode.texts.json';

import styles from './IncodeShareAuthorisationLink.module.scss';

const LocalT = new MDText(LocalTexts.shareAuthorisationLink);

export const IncodeShareAuthorisationLinkStart = ({
  incodeSession,
}: IncodeStepProps) => {
  const { IncodeProgressLoading, postIncodeComplete } = usePostIncodeProgress();

  return (
    <>
      <IncodeProgressLoading />
      <div className={styles.component}>
        <IncodeAuthorisationLink headingElement="h1" />
        <IncodeFooter>
          <Button
            fullWidth
            label={LocalT.translate('cta')}
            onClick={() => postIncodeComplete({
              fallbackNextStep: INCODE_ROUTES.CAPTURE_LICENSE,
              incodeSession,
              status: INCODE_PROGRESS_STATUS.SUCCESS,
              step: INCODE_PROGRESS_STEP.KEEPER_AUTHORIZATION,
            })}
          />
        </IncodeFooter>
      </div>
    </>
  );
};
